(function () {
  function toggleHighlight(highlight) {
    var wasOpen = highlight.classList.contains('cashback-percentage__highlight--open');
    document.querySelectorAll('.cashback-percentage__highlight--open').forEach(function (el) {
      el.classList.remove('cashback-percentage__highlight--open');
    });
    if (!wasOpen) highlight.classList.add('cashback-percentage__highlight--open');
  }

  document.addEventListener('click', function (e) {
    var highlight = e.target.closest('.cashback-percentage__highlight');
    if (highlight) {
      if (e.target.closest('.cashback-percentage__tooltip')) {
        return;
      }
      toggleHighlight(highlight);
      return;
    }
    document.querySelectorAll('.cashback-percentage__highlight--open').forEach(function (el) {
      el.classList.remove('cashback-percentage__highlight--open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var highlight = e.target.closest('.cashback-percentage__highlight');
    if (!highlight) return;
    e.preventDefault();
    toggleHighlight(highlight);
  });
})();
